<template>
    <ajax-form :action="action" :data="submitData" method="POST" v-model:loading="isLoading" reset>
        <div class="flex" :class="inline ? 'flex-row' : 'flex-column justify-end'">
            <div class="flex flex-grow-x-1">
                <div v-if="$auth.loggedIn" class="w-56">
					<form-user-role-select name="creator" :data="submitData"
										   :label="$t('action.comment_as')"
										   :selected-name="props.initialCreator"
										   v-model:selected="creator"/>
                </div>
                <form-textarea v-model="submitData.text" ref="textElement" :placeholder="placeholderText" :rows="inline ? 1 : 3" inverted hide-details :disabled="isLoading"
                               :rules="{required: true}"/>
            </div>
            <div v-if="submitData.text?.length" class="text-right" :class="{'mt-8': !inline}">
                <btn type="submit" :text="inline" color="success" :loading="isLoading" :class="{'min-w-160': !inline, 'mr--16': inline}">{{ $t('action.post') }}</btn>
            </div>
        </div>
    </ajax-form>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue';
import {useNuxtApp, useI18n} from '#imports';
import type {Ref} from 'vue';
import type {MainModelPreview} from "@spoferan/spoferan-ts-core";

const props = defineProps<{
	action: string,

	// Whether to inline the form input
	inline?: boolean,

	// The display name of the initial creator to select
	initialCreator?: string
}>();

const {$auth, $api} = useNuxtApp();
const {t} = useI18n();

const isLoading = ref(false);
const creator: Ref<MainModelPreview|null> = ref(null);
const submitData = ref({
	text: null
});
const textElement = ref(null);

const placeholderText = computed(() => {
	if (!creator.value) {
		return null;
	}
	return t('action.comment_as_name', {name: creator.value.greeting_name}) + '...';
});

</script>